import { productConstants } from "../constants";
import { ProductService } from "../../services/ProductService";

const request = (actionType) => {
  return {
    type: actionType,
  };
};

const success = (filesData, actionType) => {
  return {
    type: actionType,
    payload: filesData,
  };
};

const failure = (error, actionType) => {
  return {
    type: actionType,
    payload: error,
  };
};

export const GetQuestionTypes = (data) => {
  return async (dispatch) => {
    dispatch(request(productConstants.QUESTIONS_TYPES_REQUEST));
    try {
      const productService = ProductService.getInstance();
      const responseData = await productService.GetQuestionTypes(data);
      dispatch(success(responseData.Body, productConstants.QUESTIONS_TYPES_SUCCESS));
    } catch (error) {
      dispatch(failure(error.message, productConstants.QUESTIONS_TYPES_FAILURE));
    }
  };
};